import React from 'react'
import { Button, ButtonProps } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { lighten, getContrastRatio, darken } from '@mui/system'
import clsx from 'clsx'
import { icons } from '../../../constants/icons'

export interface AddButtonProps extends ButtonProps {
  text: string
  width: number | string
  height?: number | string
  mt?: number | string
  mb?: number | string
  ml?: number | string
  mr?: number | string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  backgroundColor?: string
  added?: boolean
}

const useStyles = makeStyles<Theme, AddButtonProps>((theme: Theme) => ({
  button: {
    minWidth: ({ width }) => width,
    marginTop: ({ mt }) => mt,
    marginBottom: ({ mb }) => mb,
    marginLeft: ({ ml }) => ml,
    marginRight: ({ mr }) => mr,
    height: ({ height }) => height || 40,
    padding: 8,
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 0,
    color: ({ backgroundColor }) =>
      // eslint-disable-next-line no-nested-ternary
      backgroundColor
        ? getContrastRatio(backgroundColor, '#fff') > getContrastRatio(backgroundColor, '#000')
          ? theme.palette.primary.light
          : theme.palette.primary.main
        : theme.palette.primary.main,
    background: ({ added, backgroundColor }) =>
      added
        ? darken(backgroundColor || theme.palette.secondary.main, 0.5)
        : backgroundColor || theme.palette.secondary.main,
    '&:hover': {
      background: ({ backgroundColor }) =>
        backgroundColor ? lighten(backgroundColor, 0.1) : theme.palette.secondary.light,
    },
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.6,
    },
  },
  check: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 0,
  },
  text: {
    textTransform: 'none',
  },
}))

export const AddButton: React.FC<AddButtonProps> = ({
  added,
  text,
  width,
  height,
  mt,
  mb,
  ml,
  mr,
  disabled,
  onClick,
  backgroundColor,
  ...props
}) => {
  const classes = useStyles({
    added,
    text,
    width,
    height,
    mt,
    mb,
    ml,
    mr,
    backgroundColor,
  })

  return (
    <Button
      disabled={disabled}
      variant="contained"
      type="submit"
      className={classes.button}
      onClick={onClick}
      {...props}
    >
      {added ? (
        <span className={clsx(classes.check, 'material-icons')}>{icons.CHECK}</span>
      ) : (
        <span className={classes.text}>{text}</span>
      )}
    </Button>
  )
}
